import * as actionTypes from './../actions/criticalCareAction';

const initialState = {
  data: [],
  selected: null,
  selectedAnorexia: false,
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT:
      return {
        ...state,
        selectedAnorexia: !action.selected ? false : state.selectedAnorexia,
        selected: action.selected,
      };

    case actionTypes.SELECT_ANOREXIA:
      return {
        ...state,
        selectedAnorexia: action.selected,
      };

    case actionTypes.DEFAULT:
      return {
        ...state,
        ready: true,
        selected: false,
        selectedAnorexia: false
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
